export const handleChatButtonClick = () => {
  window.fcWidget.open("Chat with us");
};
